import { render } from "./prizeTask.vue?vue&type=template&id=7ba0eaac&scoped=true"
import script from "./prizeTask.vue?vue&type=script&lang=js"
export * from "./prizeTask.vue?vue&type=script&lang=js"

import "./prizeTask.vue?vue&type=style&index=0&id=7ba0eaac&scoped=true&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba0eaac"]])

export default __exports__